export const OverviewIcon = () => (
    <svg
        width="18"
        height="17"
        viewBox="0 0 18 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3.15625 2.53906C4.78906 0.90625 6.73698 0.0898438 9 0.0898438C11.263 0.0898438 13.1966 0.90625 14.8008 2.53906C16.4336 4.14323 17.25 6.07682 17.25 8.33984C17.25 10.6029 16.4336 12.5508 14.8008 14.1836C13.1966 15.7878 11.263 16.5898 9 16.5898C6.73698 16.5898 4.78906 15.7878 3.15625 14.1836C1.55208 12.5508 0.75 10.6029 0.75 8.33984C0.75 6.07682 1.55208 4.14323 3.15625 2.53906ZM13.8555 3.48438C12.5091 2.13802 10.8906 1.46484 9 1.46484C7.10938 1.46484 5.49089 2.13802 4.14453 3.48438C2.79818 4.83073 2.125 6.44922 2.125 8.33984C2.125 10.2305 2.79818 11.849 4.14453 13.1953C5.49089 14.5417 7.10938 15.2148 9 15.2148C10.8906 15.2148 12.5091 14.5417 13.8555 13.1953C15.2018 11.849 15.875 10.2305 15.875 8.33984C15.875 6.44922 15.2018 4.83073 13.8555 3.48438ZM8.48438 2.36719C8.6276 2.22396 8.79948 2.15234 9 2.15234C9.20052 2.15234 9.35807 2.22396 9.47266 2.36719C9.61589 2.48177 9.6875 2.63932 9.6875 2.83984C9.6875 3.04036 9.61589 3.21224 9.47266 3.35547C9.35807 3.47005 9.20052 3.52734 9 3.52734C8.79948 3.52734 8.6276 3.47005 8.48438 3.35547C8.36979 3.21224 8.3125 3.04036 8.3125 2.83984C8.3125 2.63932 8.36979 2.48177 8.48438 2.36719ZM4.61719 4C4.76042 3.85677 4.91797 3.78516 5.08984 3.78516C5.29036 3.78516 5.46224 3.85677 5.60547 4C5.7487 4.11458 5.82031 4.27214 5.82031 4.47266C5.82031 4.64453 5.7487 4.80208 5.60547 4.94531C5.46224 5.08854 5.29036 5.16016 5.08984 5.16016C4.91797 5.16016 4.76042 5.08854 4.61719 4.94531C4.5026 4.80208 4.44531 4.64453 4.44531 4.47266C4.44531 4.27214 4.5026 4.11458 4.61719 4ZM12.3945 3.95703L13.3828 4.94531L10.332 7.99609C10.3607 8.11068 10.375 8.22526 10.375 8.33984C10.375 8.71224 10.2318 9.04167 9.94531 9.32812C9.6875 9.58594 9.3724 9.71484 9 9.71484C8.6276 9.71484 8.29818 9.58594 8.01172 9.32812C7.75391 9.04167 7.625 8.71224 7.625 8.33984C7.625 7.96745 7.75391 7.65234 8.01172 7.39453C8.29818 7.10807 8.6276 6.96484 9 6.96484C9.11458 6.96484 9.22917 6.97917 9.34375 7.00781L12.3945 3.95703ZM2.98438 7.86719C3.1276 7.72396 3.29948 7.65234 3.5 7.65234C3.70052 7.65234 3.85807 7.72396 3.97266 7.86719C4.11589 7.98177 4.1875 8.13932 4.1875 8.33984C4.1875 8.54036 4.11589 8.71224 3.97266 8.85547C3.85807 8.97005 3.70052 9.02734 3.5 9.02734C3.29948 9.02734 3.1276 8.97005 2.98438 8.85547C2.86979 8.71224 2.8125 8.54036 2.8125 8.33984C2.8125 8.13932 2.86979 7.98177 2.98438 7.86719ZM13.9844 7.86719C14.1276 7.72396 14.2995 7.65234 14.5 7.65234C14.7005 7.65234 14.8581 7.72396 14.9727 7.86719C15.1159 7.98177 15.1875 8.13932 15.1875 8.33984C15.1875 8.54036 15.1159 8.71224 14.9727 8.85547C14.8581 8.97005 14.7005 9.02734 14.5 9.02734C14.2995 9.02734 14.1276 8.97005 13.9844 8.85547C13.8698 8.71224 13.8125 8.54036 13.8125 8.33984C13.8125 8.13932 13.8698 7.98177 13.9844 7.86719ZM4.61719 11.7344C4.76042 11.5911 4.91797 11.5195 5.08984 11.5195C5.29036 11.5195 5.46224 11.5911 5.60547 11.7344C5.7487 11.8776 5.82031 12.0495 5.82031 12.25C5.82031 12.4219 5.7487 12.5794 5.60547 12.7227C5.46224 12.8372 5.29036 12.8945 5.08984 12.8945C4.91797 12.8945 4.76042 12.8372 4.61719 12.7227C4.5026 12.5794 4.44531 12.4219 4.44531 12.25C4.44531 12.0495 4.5026 11.8776 4.61719 11.7344ZM12.3945 11.7344C12.5378 11.5911 12.6953 11.5195 12.8672 11.5195C13.0677 11.5195 13.2253 11.5911 13.3398 11.7344C13.4831 11.8776 13.5547 12.0495 13.5547 12.25C13.5547 12.4219 13.4831 12.5794 13.3398 12.7227C13.2253 12.8372 13.0677 12.8945 12.8672 12.8945C12.6953 12.8945 12.5378 12.8372 12.3945 12.7227C12.2513 12.5794 12.1797 12.4219 12.1797 12.25C12.1797 12.0495 12.2513 11.8776 12.3945 11.7344Z"
            fill="currentColor"
        />
    </svg>

);
export const InsigthsIcon = () => (
    <svg
        width="20"
        height="18"
        viewBox="0 0 20 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M0.375 0.720703H1.0625H13.4375H14.125V1.4082V11.0332V11.7207H13.4375H7.50781L4.24219 14.2988L3.125 15.2441V13.7832V11.7207H1.0625H0.375V11.0332V1.4082V0.720703ZM1.75 2.0957V10.3457H3.8125H4.5V11.0332V12.3223L6.82031 10.5176L6.99219 10.3457H7.25H12.75V2.0957H1.75ZM15.5 3.4707H19.625V14.4707H16.875V17.9941L12.4922 14.4707H6.13281L7.85156 13.0957H13.0078L15.5 15.0723V13.0957H18.25V4.8457H15.5V3.4707Z"
            fill="currentColor"
        />
    </svg>

);


export const MentorsIcon = () => (
    <svg
        width="20"
        height="18"
        viewBox="0 0 20 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M5.53125 0.740234C7.19271 0.740234 8.68229 1.41341 10 2.75977C11.3177 1.41341 12.8073 0.740234 14.4688 0.740234C15.901 0.740234 17.1185 1.25586 18.1211 2.28711C19.1237 3.28971 19.625 4.49284 19.625 5.89648C19.625 6.4694 19.4818 7.05664 19.1953 7.6582C18.9089 8.23112 18.6224 8.66081 18.3359 8.94727L17.9062 9.33398L10.5156 16.8105L10 17.3262L9.48438 16.8105L2.09375 9.33398C1.80729 9.07617 1.52083 8.74674 1.23438 8.3457C0.661458 7.48633 0.375 6.66992 0.375 5.89648C0.375 4.49284 0.876302 3.28971 1.87891 2.28711C2.88151 1.25586 4.09896 0.740234 5.53125 0.740234ZM5.53125 2.11523C4.5 2.11523 3.61198 2.48763 2.86719 3.23242C2.1224 3.97721 1.75 4.86523 1.75 5.89648C1.75 6.38346 1.95052 6.94206 2.35156 7.57227L3.03906 8.38867L10 15.3496L16.9609 8.38867C17.8203 7.44336 18.25 6.61263 18.25 5.89648C18.25 4.86523 17.8776 3.97721 17.1328 3.23242C16.388 2.48763 15.5 2.11523 14.4688 2.11523C13.8672 2.11523 13.237 2.28711 12.5781 2.63086C11.9193 2.94596 11.4036 3.27539 11.0312 3.61914L10.5156 4.0918L10 4.69336L9.48438 4.0918C9.34115 3.94857 9.14062 3.77669 8.88281 3.57617C8.65365 3.34701 8.18099 3.04622 7.46484 2.67383C6.77734 2.30143 6.13281 2.11523 5.53125 2.11523Z"
            fill="currentColor"
        />
    </svg>
);

export const MeetingRequestIcon = () => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M0.4375 0.757812H1.125H14.875H15.5625V1.44531V15.1953V15.8828H14.875H1.125H0.4375V15.1953V1.44531V0.757812ZM1.8125 2.13281V7.63281H7.3125V2.13281H1.8125ZM8.6875 2.13281V7.63281H14.1875V2.13281H8.6875ZM1.8125 9.00781V14.5078H7.3125V9.00781H1.8125ZM8.6875 9.00781V14.5078H14.1875V9.00781H8.6875Z"
            fill="currentColor"
        />
    </svg>

);

export const LogoutIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth="1.5"
        stroke="currentColor"
        className="w-6 h-6">
        <path
            // stroke-linecap="round"
            // stroke-linejoin="round"
            d="M5.636 5.636a9 9 0 1 0 12.728 0M12 3v9"
        />
    </svg>


);

export const CallLogo = () => (
    <svg xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-6 h-6">
        <path d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z" />
    </svg>
);

export const VideoEngagementIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-6 h-6">
        <path stroke-linecap="round" d="M15.75 10.5l4.72-4.72a.75.75 0 011.28.53v11.38a.75.75 0 01-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25h-9A2.25 2.25 0 002.25 7.5v9a2.25 2.25 0 002.25 2.25z" />
    </svg>
);
